<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="nil"
    :form="form"
    :title="$t('model.contactForm')"
    resource="contact_forms"
    :export-props="{}"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import { filterColumnsHash, columnsHash, formColumnsHash } from '../admin_configs/contact_forms/columns';

@Component
export default class ContactForms extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      { prop: 'city_cont' },
      { prop: 'email_cont' },
      { prop: 'name_cont' },
      { prop: 'store_id_eq' },
    ].filter(Boolean).map(hash => _.merge(filterColumnsHash[hash['prop']], hash))
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      { prop: 'id' },
      { prop: 'city' },
      { prop: 'email' },
      { prop: 'name' },
      { prop: 'wechat_id' },
      { prop: 'phone' },
      { prop: 'profession' },
      { prop: 'store_id' },
      { prop: 'user_id' },
      { prop: 'created_at' },
      type === 'show' && { prop: 'updated_at' },
    ].filter(Boolean).map(hash => _.merge(columnsHash[hash['prop']], hash))
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [

    ].filter(Boolean).map(hash => _.merge(formColumnsHash[hash['prop']], hash))
  }
}

export const route = [
  {
    path: '/contact_forms',
    name: 'contact_forms.index',
    component: ContactForms,
    props: {
      type: 'index',
    }
  },
  {
    path: '/contact_forms/new',
    name: 'contact_forms.new',
    component: ContactForms,
    props: {
      type: 'new',
    }
  },
  {
    path: '/contact_forms/:id',
    name: 'contact_forms.show',
    component: ContactForms,
    props: {
      type: 'show',
    }
  },
  {
    path: '/contact_forms/:id/edit',
    name: 'contact_forms.edit',
    component: ContactForms,
    props: {
      type: 'edit'
    }
  }
]
</script>
